import { calcDestinyNumber } from './destiny.js';
import { reduceToDigit } from './reduce.js';
/**
 * Compute number compatibility between two birth dates. Both destiny
 * numbers are reduced fully (no master numbers) before pairing, since the
 * compat table only covers 9×9. Lookup key is always `lo-hi` so a-b and
 * b-a hit the same entry.
 */
export function calcNumberCompat(birthDateA, birthDateB) {
    const a = calcDestinyNumber(birthDateA);
    const b = calcDestinyNumber(birthDateB);
    const aReduced = reduceToDigit(a, false);
    const bReduced = reduceToDigit(b, false);
    const lo = Math.min(aReduced, bReduced);
    const hi = Math.max(aReduced, bReduced);
    return {
        numberA: a,
        numberB: b,
        textKey: `${lo}-${hi}`,
        stars: 3, // placeholder; actual value comes from the JSON lookup
    };
}
//# sourceMappingURL=compat.js.map